import axios from '../axios/redditlikeApi'

const validateResetPasswordToken = uuid => axios.get(`/password/${uuid}`)

const sendResetPasswordLink = reqBody => axios.post('/password/forgot', reqBody)

const resetPassword = reqBody => axios.patch('/password/reset', reqBody)

export default {
  validateResetPasswordToken,
  sendResetPasswordLink,
  resetPassword
}
